<template>
  <v-container> 
    <v-layout row wrap>
      <v-flex xs12 offset-xs9>
        
        <v-btn color="info" @click="addNew" v-if="$can('do','POKO_Rooms_Edycja')">Dodaj gabinet</v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table              
              :options.sync="pagination"
              :items="items"
              :loading="loading"
              :server-items-length="totalResults"              
              :footer-props="{
                        itemsPerPageOptions:[20,50,100,200],                        
              }"  
              :headers="headers">
              <template v-slot:item.id="{item}">
                    <v-layout align-center>
                      <v-icon small class="mr-2" @click="editRoom(item.id)" v-if="$can('do','POKO_Rooms_Edycja')" title="Edytuj">fa-edit</v-icon>
                      <v-icon small class="mr-2"  @click="deleteRoom(item.id)" v-if="$can('do','POKO_Rooms_Edycja')" title="Usuń">fa-trash-alt</v-icon>
                    </v-layout>
              </template>
          <template v-slot:item.placowkaId="{item}">
            {{getPlacowkaNazwa(item.placowkaId)}}
          </template>
          <template v-slot:item.color="{item}">
            <v-chip :color="item.color" text-color="white">{{item.color}}</v-chip>
          </template>
        </v-data-table>    
      
      </v-flex>
    </v-layout>       
    <AddEditRoom v-if="showAddRoom" :visible="showAddRoom" :id="selectedRoomId" @close="closeAddPopup" :placowki="dostepnePlacowki" />
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { roomService } from "@/services/";
import swal from "sweetalert";
import AddEditRoom from "./AddEditRoom";
export default {
  name: "Rooms",
  data() {
    return {   
      loading: true,
      showAddRoom: false,
      selectedRoomId: 0,
      totalResults: 0,
      items: [],      
      pagination: {},
      headers: [
        { text: 'Nazwa', sortable: true, align: 'left', value: 'name'},
        { text: 'Opis', sortable: true, align: 'left', value: 'description'} ,
        { text: 'Przypisana placówka', sortable: false, align: 'left', value: 'placowkaId'},
        { text: 'Przypisany kolor', sortable: false, align: 'left', value: 'color'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}        
      ]      
    }
  },
  components: { AddEditRoom},
  computed: {
    ...mapState('companySettingsModule',['settings']),
    dostepnePlacowki: function() {
      let placowki = []
      if(this.settings.additionalOutposts && this.settings.additionalOutposts.length > 0)
      {
        this.settings.additionalOutposts.forEach(elem => {
            placowki.push(elem)
        })
      }
      return placowki
    },
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    addNew() {
      this.selectedRoomId = 0
      this.showAddRoom = true
    },
    editRoom(id) {
      this.selectedRoomId = id
      this.showAddRoom = true
    },
    getPlacowkaNazwa(id)
    {
      let pl = this.dostepnePlacowki.find(x=>x.id == id)
      if(pl)
        return pl.name
      return ''
    },
    deleteRoom(id) {
      swal({
        title: "Czy na pewno?",
        text:
          "Czy na pewno chcesz usunąć ten gabinet?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          roomService
            .deleteRoom(id)
            .then(resp => {
              if (resp.data == null || !resp.data.success) {
                throw "Błąd usuwania gabinetu";
              } else {
                this.success("Usunięto");
                this.refreshTable()
              }
            })
            .catch(e => {
              console.log(e);
              this.error("Nie można usunąć gabinetu");
            });
        }
      });
    },
    closeAddPopup() {
      this.refreshTable()
      this.showAddRoom = false
      this.selectedRoomId = 0
    },
    refreshTable()
    {
          this.loading = true

          this.requestRooms().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
    },
    requestRooms() {   
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      var req = roomService.getAll({ query: '', page: page, limit: itemsPerPage, sorting: sortValue });
      return req.catch(function() {
        this.error("Błąd pobierania gabinetów");
      });
    }
  },
  created() {
    this.updateTitle("Gabinety");
  },
  beforeMount() {},
    watch: {
      pagination: {
        handler() {
          this.requestRooms().then(data=> {
            this.items = data.data.result.items,
            this.totalResults = data.data.result.totalCount
            this.loading = false
          })    
        },
        deep: true
      }
    },  
};
</script>

<style>
  .data-table-poko #rooms {
    margin-top: 60px;
  }

</style>
